import { Menu, MenuItem, styled } from '@mui/material';

import { palette } from '@setup/theme/palette';

export const PaperActionMenuContainer = styled(Menu, {
  shouldForwardProp: (prop: string) => !['isSmall'].includes(prop),
})<{ isSmall?: boolean }>(({ theme, isSmall }) => ({
  '& .MuiBackdrop-root': {
    backgroundColor: 'transparent',
  },

  '& .MuiMenu-paper': {
    marginTop: theme.spacing(1),
    boxShadow: palette.case.shadow.default,
    padding: '4px',
    width: isSmall ? 'auto' : '208px',
    maxHeight: '226px',
    border: `1px solid ${theme.palette.case.neutral.n200}`,
    backgroundColor: theme.palette.case.background,
    '& .MuiList-root': {
      padding: 0,
    },
  },
}));

export const PaperActionMenuItem = styled(MenuItem, {
  shouldForwardProp: (prop: string) =>
    !['isHideIcon', 'iconColor', 'isSmall', 'isSetIconSize'].includes(prop),
})<{ isHideIcon?: boolean; iconColor?: string; isSmall?: boolean; isSetIconSize?: boolean }>(
  ({ theme, isHideIcon, iconColor, isSmall, isSetIconSize }) => ({
    boxShadow: 'none',
    display: 'flex',
    alignItems: 'center',
    height: isSmall ? '24px' : '36px',
    minHeight: '24px',
    fontSize: isSmall ? theme.typography.t12r.fontSize : theme.typography.t14r.fontSize,
    lineHeight: isSmall ? theme.typography.t12r.lineHeight : theme.typography.t14r.lineHeight,
    fontWeight: isSmall ? theme.typography.t12r.fontWeight : theme.typography.t14r.fontWeight,
    svg: {
      width: isSetIconSize ? '24px' : 'default',
      height: isSetIconSize ? '24px' : 'default',
      opacity: isHideIcon ? '0' : ' 1',
      display: isHideIcon ? 'none' : 'block',
      path: {
        fill: iconColor ?? '',
      },
    },
  }),
);
